import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";

/**
 * ClientLogoutLink — tiny inline "Logout" link that only renders when a
 * client is signed in. Clears the token and dispatches the same
 * kl-auth-change event the rest of the app listens for.
 */
export default function ClientLogoutLink({ language = "en", className = "" }) {
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const sync = () => setSignedIn(!!localStorage.getItem("client_token"));
    sync();
    window.addEventListener("storage", sync);
    window.addEventListener("kl-auth-change", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("kl-auth-change", sync);
    };
  }, []);

  if (!signedIn) return null;

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("client_token");
    window.dispatchEvent(new Event("kl-auth-change"));
    // Stay on the same page — auth-aware components react instantly.
    setSignedIn(false);
  };

  return (
    <button
      type="button"
      onClick={handleLogout}
      className={`text-[11px] text-stone-500 hover:text-stone-800 inline-flex items-center gap-1 transition-colors ${className}`}
      data-testid="header-logout-link"
      aria-label={language === "fr" ? "Se déconnecter" : "Log out"}
    >
      <LogOut className="w-3 h-3" />
      {language === "fr" ? "Déconnexion" : "Log out"}
    </button>
  );
}
